import Loading from '@/components/common/Loading';
import { apiSdkAtom } from '@/context/atoms/ApiSdk';
import { authMechanismAtom } from '@/context/atoms/AuthMechanism';
import { publicConfigAtom } from '@/context/atoms/publicConfig';
import { systemConfigRootAtom } from '@/context/atoms/systemConfig';
import { userPermissionsAtom } from '@/context/atoms/UserPermissions';
import { NoSsr } from '@mui/material';
import { createStore, Provider, useAtomValue } from 'jotai';
import React, { Suspense } from 'react';

const PreloaderPublicConfig = (): null => {
  useAtomValue(publicConfigAtom);
  return null;
};

const Preloader = (): null => {
  useAtomValue(authMechanismAtom);
  useAtomValue(apiSdkAtom);
  useAtomValue(userPermissionsAtom);
  return null;
};

const PreloaderSystemConfig = (): null => {
  useAtomValue(systemConfigRootAtom);
  return null;
};

export default function AtomProvider({ children }: { children: React.ReactNode }): React.JSX.Element {
  const store = createStore();
  return (
    <Provider store={store}>
      <NoSsr>
        <Suspense fallback={<Loading size={150} />}>
          <PreloaderPublicConfig />
          <Suspense fallback={<Loading size={150} />}>
            <Preloader />
            <Suspense fallback={<Loading size={150} />}>
              <PreloaderSystemConfig />
              {children}
            </Suspense>
          </Suspense>
        </Suspense>
      </NoSsr>
    </Provider>
  );
}
